import { ThemeProvider } from '@mui/material';
import React from 'react';
import { ColorModeService } from '../../../core/services/color-mode.service';
import { useObservableState } from '../../../core/hooks/useObservableState';
import useService from '../../../injector/hooks/useService';
import { activeTheme } from '../../constants/theme';

export default function ThemeWrapper({ children }) {
  const colorModeService = useService(ColorModeService);
  const [theme] = useObservableState(colorModeService.colorMode$);

  return (
    <ThemeProvider theme={activeTheme(theme)}>
      {children}
    </ThemeProvider>
  );
}
